export interface ILogger {
	logTrace: (message: string) => void;
	logWarning: (message: string) => void;
	logException: (message: string, ex: any) => void;
}

export const Logger: ILogger = {
	logTrace: (message: string) => console.debug(message),
	logWarning: (message: string) => console.warn(message),
	logException: (message: string, ex: any) => console.error(message, ex)
}